@if (operation) {
<tec-collapse [title]="`WORKFLOWS.FORM.OPERATIONS.${operation.type}` | translate" [badge]="index.toString()">
    <app-developer-curl-button
        ngProjectAs="tec-button-icon"
        [path]="operationCurlPath()"
        titleKey="WORKFLOWS.CURL_MODAL.TITLE_OPERATION"
    />
    <tec-tile
        [title]="'WORKFLOWS.FORM.OPERATIONS.TERMS_AND_CONDITIONS' | translate"
        [subtitle]="'WORKFLOWS.FORM.OPERATIONS.TERMS_AND_CONDITIONS_DESCRIPTION' | translate"
    >
        <tec-item
            title="Tecalis"
            [tagImage]="{ icon: 'icon-check-circle', status: 'default' }"
            [clickeable]="false"
            collapse
        >
            <tec-tag [label]="'WORKFLOWS.FORM.OPERATIONS.MANDATORY' | translate" status="warning"></tec-tag>
            <span [innerHTML]="safeTecalisPolicy"></span>
        </tec-item>

        @for (policy of operation?.config?.policy_checks; track $index) {
        <tec-item
            [title]="policy.custom_id"
            [tagImage]="{ icon: 'icon-check-circle', status: 'default' }"
            [clickeable]="false"
            collapse
        >
            <tec-tag
                [label]="
                    policy.required
                        ? ('WORKFLOWS.FORM.OPERATIONS.MANDATORY' | translate)
                        : ('WORKFLOWS.FORM.OPERATIONS.OPTIONAL' | translate)
                "
                [status]="policy.required ? 'warning' : 'default'"
            />
            <span [innerHTML]="getSanitizedPolicy($index)"></span>
        </tec-item>
        }
    </tec-tile>

    <tec-tile [title]="'WORKFLOWS.FORM.CONF_ADVANCED' | translate">
        <tec-info-group
            [label]="'WORKFLOWS.FORM.OPERATIONS.INDICATIONS' | translate"
            [tooltip]="'WORKFLOWS.FORM.OPERATIONS.DESCRIPTION_EXT' | translate"
        >
            <app-text-locale-preview [textLocale]="operation?.config?.description" />
        </tec-info-group>
    </tec-tile>
</tec-collapse>
}
